import MainLayout from '../../shared/common/components/layouts/MainLayout';
import PageHead from '../../shared/common/components/page-header/PageHeader';

const AccessEnded = () => {
  return (
    <MainLayout pageTitle="">
      <div className="page-wrapper">
        <PageHead title="Доступ закончился, обратитесь к администратору." />
      </div>
    </MainLayout>
  );
};

export default AccessEnded;
